import { cardNode } from "../fragments/cardNode";

const allContentItems = (
    lineupID,
    lineupSlug,
    categorySlug,
    pageSize,
    subjectsSet = "",
    excludedCategorySet = "",
    subjects = "",
    tags = ""
) => {
    const concepts = subjects ? `subject:${subjects}` : "";
    let categorySlugQueryString = "";

    if (categorySlug)
        categorySlugQueryString = `categorySlug: "${categorySlug}",`;

    return {
        query: `${lineupID}: allContentItems(lineupSlug: "${lineupSlug}",${categorySlugQueryString}
            subjectsSet: "${subjectsSet}",
            pageSize: ${pageSize},
            concepts: "${concepts}",
            excludedCategorySet: "${excludedCategorySet}",
            tags: "${tags}",
            typeSet: CBC_OCELOT,
            targets: [WEB,ALL]) {
                nodes {
                    ...cardNode
                }
            }`,

        fragment: cardNode,
    };
};

const allContentItemsWithFragment = (
    fragment = { name: "cardNode", value: cardNode }
) => {
    return `query allContentItemsWithFragment($lineupSlug: String, $pageSize: Int, $type: String, $mediaAspectRatios: [ContentItemAspectRatio!]) {
        allContentItems(lineupSlug: $lineupSlug, pageSize: $pageSize, type: $type, targets: [WEB,ALL], mediaAspectRatios: $mediaAspectRatios) {
            nodes {
                ...${fragment.name}
            }
        }
    }${fragment.value}
`;
};

// Schema for Single Lineup Category Query
const singleLineup = `query singleLineup($lineupSlug: String, $categorySlug: String, $concepts: String, $subjectsSet: String, $tags: String, $pageSize: Int, $page: Int) {
    allContentItems(lineupSlug: $lineupSlug, categorySlug: $categorySlug, concepts: $concepts, subjectsSet: $subjectsSet, tags: $tags, pageSize: $pageSize, page: $page, typeSet: CBC_OCELOT, targets: [WEB,ALL]) {
        nodes {
            ...cardNode
        }
    }
} ${cardNode}`;

// Schema for Single Lineup Topic Query (excludes Sponsor Content in typeSet)
const singleTopicLineup = `query singleLineup($lineupSlug: String, $categorySlug: String, $concepts: String, $subjectsSet: String, $tags: String, $pageSize: Int, $page: Int) {
    allContentItems(lineupSlug: $lineupSlug, categorySlug: $categorySlug, concepts: $concepts, subjectsSet: $subjectsSet, tags: $tags, pageSize: $pageSize, page: $page, typeSet: CBC_OCELOT_TOPICS_PAGE, targets: [WEB,ALL]) {
        nodes {
            ...cardNode
        }
    }
} ${cardNode}`;

// Schema for Multiple Lineup Categories Query
const multipleLineup = (lineups, pageSize) => {
    return `query {
        ${lineups
            .map(({ lineupID, lineupSlug, categorySlug }) => {
                return allContentItems(
                    lineupID,
                    lineupSlug,
                    categorySlug,
                    pageSize
                ).query;
            })
            .join("")}
    } ${cardNode}`;
};

/**
 * localSubject creates a QueryObj for local/regional queries, which are filtered by Polopoly subjects.
 * @param alias {string} - A graphql alias.
 * @param {string} slug - The regional slug.
 * @param {string} subjects - The Polopoly subjects reference.
 * @param {number} count - The number of items.
 * @return {QueryObj} The allContentItems QueryObj.
 */

const localSubject = (
    alias,
    slug,
    subjects,
    count,
    excludedCategorySet = ""
) => {
    if (!alias && !slug && !subjects) {
        return {};
    }

    return allContentItems(
        alias,
        "",
        slug,
        count,
        "",
        excludedCategorySet,
        subjects
    );
};

const allContentItemsByItemsQueryFilters = () => {
    return `query contentItemsByItemsQueryFilters($itemsQueryFilters: ItemsQueryFilters, $page: Int, $pageSize: Int, $minPubDate: String, $maxPubDate: String, $lineupOnly: Boolean, $offset: Int) {
        allContentItems(itemsQueryFilters: $itemsQueryFilters, page: $page, pageSize: $pageSize, offset: $offset, minPubDate: $minPubDate, maxPubDate: $maxPubDate, lineupOnly: $lineupOnly, targets: [WEB,ALL]) {
            nodes {
                ...cardNode
            }
        }
    } ${cardNode}`;
};

export {
    allContentItems,
    allContentItemsWithFragment,
    localSubject,
    singleLineup,
    singleTopicLineup,
    multipleLineup,
    allContentItemsByItemsQueryFilters,
};
